export default __webpack_public_path__ + "fonts/AvenirLTPro-Light.woff2";